import { Box, styled } from '@mui/material';

interface FlexBetweenProps {}

export const FlexBetween = styled(Box)<FlexBetweenProps>({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});
